{
  "REGISTER": {
    "TRY_WOOT": "Nieuw account aanmaken",
    "TITLE": "Registreren",
    "TESTIMONIAL_HEADER": "Er is maar één stap nodig om vooruit te komen",
    "TESTIMONIAL_CONTENT": "U bent één stap verwijderd van het communiceren met uw klanten, ze te behouden en nieuwe te vinden.",
    "TERMS_ACCEPT": "Door het aanmaken van een account, gaat u akkoord met onze <a href=\"https://chat.jarabot.com/terms\">T & C</a> en <a href=\"https://chat.jarabot.com/privacy-policy\">Privacy policy</a>",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Algemene voorwaarden</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Privacybeleid</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Registreren met Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Bedrijfsnaam",
      "PLACEHOLDER": "Enter your company name. eg: Wayne Enterprises",
      "ERROR": "Company name is too short"
    },
    "FULL_NAME": {
      "LABEL": "Volledige naam",
      "PLACEHOLDER": "Voer je volledige naam in, bijvoorbeeld Bruce Wayne",
      "ERROR": "Volledige naam is te kort"
    },
    "EMAIL": {
      "LABEL": "Werk e-mail",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Please enter a valid work email address"
    },
    "PASSWORD": {
      "LABEL": "Wachtwoord",
      "PLACEHOLDER": "Wachtwoord",
      "ERROR": "Wachtwoord is te kort",
      "IS_INVALID_PASSWORD": "Password should contain atleast 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Bevestig wachtwoord",
      "PLACEHOLDER": "Bevestig wachtwoord",
      "ERROR": "Wachtwoord komt niet overeen"
    },
    "API": {
      "SUCCESS_MESSAGE": "Registratie geslaagd",
      "ERROR_MESSAGE": "Kan geen verbinding maken met Woot Server, probeer het later opnieuw"
    },
    "SUBMIT": "Account aanmaken",
    "HAVE_AN_ACCOUNT": "Heeft u al een account?"
  }
}
